import { get, isEmpty } from 'lodash';

function hasRecall(referral = {}) {
  const recalledFromGroupId = get(referral, 'recalled_from_group.id');
  return !isEmpty(recalledFromGroupId);
}

export default hasRecall;
